import { render, staticRenderFns } from "./PaperShow.vue?vue&type=template&id=ed58dd82&scoped=true"
import script from "./PaperShow.vue?vue&type=script&lang=js"
export * from "./PaperShow.vue?vue&type=script&lang=js"
import style0 from "./PaperShow.vue?vue&type=style&index=0&id=ed58dd82&prod&lang=less&scoped=true"
import style1 from "./PaperShow.vue?vue&type=style&index=1&id=ed58dd82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed58dd82",
  null
  
)

export default component.exports